import logSupportButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/price/price_to_support_chat_button_click';
import { Card, Cell, CellText, Title, useBreakpoint } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import MagritteWrapper from 'src/components/MagritteWrapper/MagritteWrapper';
import SupportChatPlate from 'src/components/SupportChatPlate';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { ContactPhonePostfix } from 'src/models/contactPhones';

import styles from './index.less';

const TrlKeys = {
    contact: 'employer.auth.contact.withoutColon',
    regions: {
        [ContactPhonePostfix.Msk]: 'helpPhone.title.msk',
        [ContactPhonePostfix.Spb]: 'helpPhone.title.spb',
        [ContactPhonePostfix.Regions]: 'helpPhone.title.regions',
        [ContactPhonePostfix.City]: 'helpPhone.title.city',
        [ContactPhonePostfix.Mobile]: 'helpPhone.title.mobile',
        [ContactPhonePostfix.Other]: 'helpPhone.title.other',
    },
    andRegions: 'employer.auth.city.region',
    helpPhone: 'newEmployer.helpphonelabel',
};

const CAPITALS = ['msk', 'spb'];

const NeedHelp: TranslatedComponent = ({ trls }) => {
    const contactPhones = useSelector((state) => state.contactPhones);
    const { isMobile } = useBreakpoint();

    return (
        <Card borderWidth="default" padding={isMobile ? 12 : 24} borderRadius={24} stretched>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    <Title Element="h5" size="small">
                        {trls[TrlKeys.contact]}
                    </Title>
                </div>
                <div className={styles.supportChat}>
                    <MagritteWrapper isEnabled>
                        <SupportChatPlate
                            view={isMobile ? 'button' : 'inline'}
                            fromLabel="price_support"
                            onClick={logSupportButtonClick}
                        />
                    </MagritteWrapper>
                </div>
                <div className={styles.phones}>
                    {contactPhones.map((phone) => (
                        <Cell key={phone.postfix}>
                            <CellText type="subtitle">
                                {trls[TrlKeys.regions[phone.postfix]]}
                                {CAPITALS.includes(phone.postfix) && trls[TrlKeys.andRegions]}
                            </CellText>
                            <CellText>
                                {phone.country} {phone.city} {phone.number}
                            </CellText>
                        </Cell>
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default translation(NeedHelp);
